/**
 * API Configuration Module
 *
 * This module centralizes all API-related configuration settings.
 * It ensures that API URLs and other settings are defined in one place
 * and consistently used throughout the application.
 */

// Determine if we're in development mode
const isDevelopment = process.env.NODE_ENV === "development";

// Base URL for API requests
// In development, we use an empty string to leverage the proxy in package.json
// In production, we use the REACT_APP_API_BASE_URL environment variable
export const API_BASE_URL = isDevelopment
  ? "" // Empty string means use relative URLs with the proxy
  : process.env.REACT_APP_API_BASE_URL || "";

// If API_BASE_URL is empty and not in development mode, provide a warning
if (!API_BASE_URL && !isDevelopment) {
  // Only log in development, not in production
  if (isDevelopment) {
    console.warn(
      "API_BASE_URL is not defined. Please set REACT_APP_API_BASE_URL environment variable."
    );
  }
}

// API Endpoints
export const API_ENDPOINTS = {
  // Authentication
  LOGIN: `${API_BASE_URL}api/token/`,
  LOGOUT: `${API_BASE_URL}api/logout/`,
  REFRESH: `${API_BASE_URL}api/token/refresh/`,

  // Articles
  ARTICLES: `${API_BASE_URL}api/article/`,
  ARTICLE_DETAIL: (id) => `${API_BASE_URL}api/article/${id}/`,
  BULK_UPLOAD_ARTICLES: `${API_BASE_URL}api/bulk-upload-articles/`,
  FETCH_SAVE_SINGLE_ARTICLE: `${API_BASE_URL}api/fetch-save-single-article/`,
  FETCH_SAVE_ARTICLES: `${API_BASE_URL}api/fetch-save-articles/`,

  // Scripts
  SCRIPTS: `${API_BASE_URL}api/script/`,
  SCRIPT_DETAIL: (id) => `${API_BASE_URL}api/script/?pk=${id}`,
  GENERATE_SCRIPT: `${API_BASE_URL}api/generate-script/`,
  PUBLISHED_SCRIPTS: `${API_BASE_URL}api/published-scripts/`,
  PROMPT_TEMPLATES: `${API_BASE_URL}api/prompt-template/`,
  REGENERATE_SCRIPT: `${API_BASE_URL}api/regenerate-script/`,

  // Videos
  VIDEOS: `${API_BASE_URL}api/generated-video/`,
  VIDEO_DETAIL: (id) => `${API_BASE_URL}api/generated-video/${id}/`,
  GENERATE_VIDEO: `${API_BASE_URL}api/video/generate/`,
  VIDEO_STATUS: (id) => `${API_BASE_URL}api/video/status/${id}/`,
};

export default {
  API_BASE_URL,
  API_ENDPOINTS,
  isDevelopment,
};
